(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  class SortBy extends HTMLElement {
    connectedCallback() {
      this.formEl = this.querySelector('form');
      this.sortBySelectEl = this.querySelector('select[name="sort_by"]');

      if (!this.formEl || !this.sortBySelectEl) return;

      this.changeHandler = this.changeHandler.bind(this);
      this.sortBySelectEl.addEventListener('change', this.changeHandler);

      this.formDataHandler = this.formDataHandler.bind(this);
      this.formEl.addEventListener('formdata', this.formDataHandler);

      // The submit button is only needed as a fallback when JS is unavailable.
      this.submitButtonEl = this.formEl.querySelector('button[type="submit"]');
      if (this.submitButtonEl) this.submitButtonEl.hidden = true;
    }

    disconnectedCallback() {
      this.sortBySelectEl?.removeEventListener('change', this.changeHandler);
      this.formEl?.removeEventListener('formdata', this.formDataHandler);
    }

    // Leave sort_by out of the URL when it's the collection's default sort.
    formDataHandler(event) {
      if (event.formData.get('sort_by') === this.dataset.defaultSort) {
        event.formData.delete('sort_by');
      }
    }

    changeHandler() {
      this.formEl.requestSubmit ? this.formEl.requestSubmit() : this.formEl.submit();
    }
  }

  if(customElements.get('sort-by') === undefined) {
    customElements.define('sort-by', SortBy);
  }

  class CollectionFiltersForm extends HTMLElement {
    connectedCallback() {
      this.formEl = this.querySelector('form');

      if (!this.formEl) return;

      this.formDataHandler = this.formDataHandler.bind(this);
      this.formEl.addEventListener('formdata', this.formDataHandler);
    }

    disconnectedCallback() {
      this.formEl?.removeEventListener('formdata', this.formDataHandler);
    }

    // Drop empty fields (e.g. unset price inputs) so they don't end up in the URL.
    formDataHandler(event) {
      for (const [name, value] of [...event.formData.entries()]) {
        if (value === '') event.formData.delete(name);
      }
    }
  }

  if(customElements.get('collection-filters-form') === undefined) {
    customElements.define('collection-filters-form', CollectionFiltersForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class MainNav extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.menuButton = document.getElementById('menu-button');

      this.menuButton.addEventListener('click', () => {
        if (this.hasAttribute('open')) {
          this.close();
        } else {
          this.open();
        }
      });

      this.addEventListener('click', (event) => {
        if (event.target === this) {
          this.close();
        }
      });

      this.querySelectorAll('.header__menu--parent-link-wrapper').forEach((detailsEl) => {
        detailsEl.addEventListener('toggle', event => {
          if (!detailsEl.open) {
            detailsEl.querySelectorAll('details').forEach((otherDetailsEl) => {
              otherDetailsEl.removeAttribute('open');
            });
          }
        });
      });
    }


    open() {
      this.setAttribute('open', '');
    }

    close() {
      console.log('close!');
      this.removeAttribute('open');
      this.querySelectorAll('details[open]').forEach((details) => {
        details.removeAttribute('open');
      });
    }
  }

  customElements.define('main-nav', MainNav);

  class CloseButton extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.addEventListener('click', () => {
        this.closest('[open]').removeAttribute('open');
      });
    }
  }
  customElements.define('close-button', CloseButton);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  class StorefrontPasswordModal extends HTMLElement {
    constructor() {
      super();

      this.dialog = this.querySelector('dialog');

      if (this.querySelector('input[aria-invalid="true"]')) {
        this.dialog.showModal();
      }
    }
  }

  customElements.define('storefront-password-modal', StorefrontPasswordModal);



  } catch(e) { console.error(e); }
})();
})();
